import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PERMISSION_MODULES, PERMISSION_SUB_MODULES } from '@/shared/const'
import { Can } from '@/shared/permissions/context'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PathCard } from '@/shared/ui/path-card'
import { PermissionGuard } from '@/shared/ui/permission-guard'

export const Route = createFileRoute('/_auth/reports/')({
  staticData: {
    meta: {
      title: 'Отчеты',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <PermissionGuard permission={PERMISSION_MODULES.REPORTING}>
      <PageWrapper title={t('Отчеты')}>
        <Can I="read" a={PERMISSION_SUB_MODULES.VOUCHER_REPORT_SCHOOL}>
          <PathCard path="/reports/vouchers" title={t('Отчет по ваучерам')} />
        </Can>
        <Can I="read" a={PERMISSION_SUB_MODULES.ATTENDANCE_REPORT}>
          <PathCard path="/reports/attendance" title={t('Отчет посещаемости')} />
        </Can>
        <Can I="read" a={PERMISSION_SUB_MODULES.VOUCHER_REPORT_SCHOOL}>
          <PathCard
            path="/reports/no-meal-vouchers"
            title={t('Список учеников не получивших питание за период')}
          />
        </Can>
      </PageWrapper>
    </PermissionGuard>
  )
}
